import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export const growersTabs = ['current-campaign', 'past-reports', 'recommendations'] as const;
const rvsTabs = ['current-campaign', 'past-reports', 'recommendations'] as const;
export type GrowersTabType = (typeof growersTabs)[number];
export type RVsTabType = (typeof rvsTabs)[number];

export const useTabs = () => {
    const [searchParams, setSearchParams] = useSearchParams({
        tab: 'current-campaign',
    });
    const tabParam = searchParams.get('tab') as GrowersTabType;
    const [tab, setTab] = useState<GrowersTabType>(tabParam);
    const handleTabChange = (newValue: string) => {
        if (!growersTabs.includes(newValue)) return;
        setTab(newValue as GrowersTabType);
        setSearchParams(
            { tab: newValue },
            {
                replace: true,
            }
        );
    };

    return { tab, handleTabChange };
};
